import React from 'react';
import { SectionHeroProps } from './types';
import { HeroConsolidatedProps } from 'components/HeroConsolidated/types';
import { HeroCarouselProps } from 'components/HeroConsolidated/Carousel/types';
import { HomepageHeroProps } from 'components/HomepageHero/types';
import HeroConsolidated from '../HeroConsolidated/HeroConsolidated';
import HeroCarousel from '../HeroConsolidated/Carousel/HeroCarousel';
import HomepageHero from '../HomepageHero/HomepageHero';

/**
 * Renders a hero section that can contain any hero module
 * Specifically used when we need to render different hero modules in one Ninetailed experience
 * @param props - Props including the hero content
 * @returns The rendered hero section component
 */
const SectionHero = (props: SectionHeroProps) => {
  const { hero } = props;

  if (!hero) {
    return null;
  }

  switch (hero.__typename) {
    case 'HeroConsolidated':
      return <HeroConsolidated {...(hero as HeroConsolidatedProps)} />;
    case 'HeroCarousel':
      return <HeroCarousel {...(hero as HeroCarouselProps)} />;
    case 'HomepageHero':
      return <HomepageHero {...(hero as HomepageHeroProps)} />;
    default:
      console.warn(`Unsupported hero type: ${hero.__typename}`);
      return null;
  }
};

export default SectionHero;
